import BaseQlError   from "./BaseQlError";
import {ApolloError} from "@apollo/client/core";

export default class InternalError extends BaseQlError {
	constructor(error: ApolloError) {
		super(error);
	}
}
